import { authApi } from "./userApi";

const EMAIL_URL = "/users/profile/email";

const emailApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    changeEmail: builder.mutation<
      { message: string; pending_email: string },
      { email: string }
    >({
      query: (body) => ({ url: EMAIL_URL, method: "POST", body }),
      invalidatesTags: ["UserData"],
    }),
    confirmEmailChange: builder.mutation<
      { message: string },
      { token: string }
    >({
      query: (body) => ({ url: `${EMAIL_URL}/confirm`, method: "POST", body }),
      invalidatesTags: ["UserData"],
    }),
  }),
});

export const { useChangeEmailMutation, useConfirmEmailChangeMutation } =
  emailApi;
